import { Routes } from '@angular/router';
import { AuthGuard } from '../app/services/auth.gaurd';
import { preventBackButtonGuard } from './services/prevent-backbutton';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'landing',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./user-account/login/login.page').then(m => m.LoginPage),
  },
  {
    path: 'shared',
    loadComponent: () =>
      import('./components/shared/shared.page').then(m => m.SharedPage),
  },
  {
    path: 'landing',
    loadComponent: () =>
      import('./landing/landing.page').then(m => m.LandingPage),
  },
  {
    path: 'maintenance',
    loadComponent: () =>
      import('./maintenance/maintenance-message/maintenance-message.page').then(
        m => m.MaintenanceMessagePage
      ),
    data: { title: 'Maintenance' },
  },
  {
    path: 'change-password',
    loadComponent: () =>
      import(
        './footer/profile-settings/change-password/change-password.page'
      ).then(m => m.ChangePasswordPage),
  },
  {
    path: 'security-questions',
    loadComponent: () =>
      import(
        './footer/profile-settings/change-password/security-questions/security-questions.page'
      ).then(m => m.SecurityQuestionsPage),
  },
  {
    path: 'change-password-confirmation',
    loadComponent: () =>
      import(
        './footer/profile-settings/change-password/change-password-confirmation/change-password-confirmation.page'
      ).then(m => m.ChangePasswordConfirmationPage),
  },
  // {
  //   path: 'home',
  //   loadComponent: () => import('./footer/home/home.page').then(m => m.HomePage),
  //   canLoad: [AuthGuard],
  //   canDeactivate: [preventBackButtonGuard],
  // },
  {
    path: 'faqs',
    loadChildren: () =>import('./side-menu/faqs/faqs-routes').then(m => m.routes),
  },
   
  {
    path: 'reset-password',
    loadChildren: () =>import('./user-account/reset-password/reset-password-routes').then(m => m.routes)
  },
  {
    path: 'application-status',
    loadComponent: () =>
      import('./side-menu/application-status/application-status.page').then(
        m => m.ApplicationStatusPage
      ),
  },
  {
    path: 'customer-service',
    loadChildren: () =>
      import('./customer-service/customer-service-routes').then(m => m.routes),
  },
  {
    path: 'helpful-information',
    loadComponent: () =>
      import('./side-menu/helpful-information/helpful-information.page').then(
        m => m.HelpfulInformationPage
      ),
  },

  {
    path: 'technical-support',
    loadComponent: () =>
      import('./side-menu/technical-support/technical-support.page').then(
        m => m.TechnicalSupportPage
      ),
  },
  {
    path: 'registration',
    loadComponent: () =>
      import('./user-account/registration/registration.page').then(
        m => m.RegistrationPage
      ),
  },
  {
    path: 'tabs',
    loadChildren: () => import('./footer/tabs/tabs-routes').then(m => m.routes),
    canLoad: [AuthGuard],
  },
  {
    path: 'more',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import('./footer/more/more.page').then(m => m.MorePage),
  },
  {
    path: 'direct-deposit-agreement',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import('./payments/direct-deposit/direct-deposit-agreement.page').then(
        m => m.DirectDepositAgreementPage
      ),
  },
  {
    path: 'direct-deposit-detail',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import(
        './payments/direct-deposit/direct-deposit-details/direct-deposit.page'
      ).then(m => m.DirectDepositPage),
  },
  {
    path: 'direct-deposit-review',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import(
        './payments/direct-deposit/direct-deposit-review/direct-deposit-review.page'
      ).then(m => m.DirectDepositReviewPage),
  },
  {
    path: 'direct-deposit-confirmation',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import(
        './payments/direct-deposit/direct-deposit-confirmation/direct-deposit-confirmation.page'
      ).then(m => m.DirectDepositConfirmationPage),
  },
  {
    path: 'email-subscription',
    loadComponent: () =>
      import(
        './footer/profile-settings/email-subscription/email-subscription.page'
      ).then(m => m.EmailSubscriptionPage),
  },
  {
    path: 'email-subscription-confirmation',
    loadComponent: () =>
      import(
        './footer/profile-settings/email-subscription/email-subscription-confirmation/email-subscription-confirmation.page'
      ).then(m => m.EmailSubscriptionConfirmationPage),
  },
  {
    path: 'profile-settings',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import('./footer/profile-settings/profile-settings.page').then(
        m => m.ProfileSettingsPage
      ),
  },
  {
    path: 'case-activity',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import('./case-activity/case-activity.page').then(
        m => m.CaseActivityPage
      ),
  },
  {
    path: 'home-detail',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import('./footer/home/home-detail/home-detail.page').then(
        m => m.HomeDetailPage
      ),
  },
  {
    path: 'request-appointment',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import('./appointments/request-appointment.page').then(
        m => m.RequestAppointmentPage
      ),
  },
  {
    path: 'request-appointment-options',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import(
        './appointments/request-appointment-options/request-appointment-options.page'
      ).then(m => m.RequestAppointmentOptionsPage),
  },
  {
    path: 'request-appointment-review',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import(
        './appointments/request-appointment-review/request-appointment-review.page'
      ).then(m => m.RequestAppointmentReviewPage),
  },
  {
    path: 'request-appointment-confirmation',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import(
        './appointments/request-appointment-confirmation/request-appointment-confirmation.page'
      ).then(m => m.RequestAppointmentConfirmationPage),
  },
  {
    path: 'notifications',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import('./footer/notifications/notifications.page').then(
        m => m.NotificationsPage
      ),
  },
  {
    path: 'view-profile',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import('./footer/profile-settings/view-profile/view-profile.page').then(
        m => m.ViewProfilePage
      ),
  },
  {
    path: 'save-profile',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import('./footer/profile-settings/save-profile/save-profile.page').then(
        m => m.SaveProfilePage
      ),
  },
  {
    path: 'save-profile-confirmation',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import(
        './footer/profile-settings/save-profile/save-profile-confirmation/save-profile-confirmation.page'
      ).then(m => m.SaveProfileConfirmationPage),
  },
  {
    path: 'access-menu',
    loadComponent: () =>
      import('./side-menu/access-menu/access-menu.page').then(
        m => m.AccessMenuPage
      ),
  },
  {
    path: 'registration-success',
    loadComponent: () =>
      import(
        './user-account/registration/registration-success/registration-success.page'
      ).then(m => m.RegistrationSuccessPage),
  },
  {
    path: 'payment-history',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import('./payments/payment-history/payment-history.page').then(
        m => m.PaymentHistoryPage
      ),
  },
  {
    path: 'payment-history-detail',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import(
        './payments/payment-history/payment-history-detail/payment-history-detail.page'
      ).then(m => m.PaymentHistoryDetailPage),
  },
  {
    path: 'payment-history-for-case',
    loadComponent: () =>
      import(
        './payments/payment-history/payment-history-for-case/payment-history-for-case.page'
      ).then(m => m.PaymentHistoryForCasePage),
  },
  {
    path: 'capture-image',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import('./document-upload/capture-image/capture-image.page').then(
        m => m.CaptureImagePage
      ),
  },
  {
    path: 'document-review',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import('./document-upload/document-review/document-review.page').then(
        m => m.DocumentReviewPage
      ),
  },
  {
    path: 'multi-page-option',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import('./multi-page-option/multi-page-option.page').then(
        m => m.MultiPageOptionPage
      ),
  },
  {
    path: 'document-upload',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import('./document-upload/document-upload.page').then(
        m => m.DocumentUploadPage
      ),
  },
  {
    path: 'document-type',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import('./document-upload/document-type/document-type.page').then(
        m => m.DocumentTypePage
      ),
  },
  {
    path: 'document-upload-dd-steps',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import('./document-upload/document-upload-dd-steps/document-upload-dd-steps.page').then(
        m => m.DocumentUploadDDPage
      ),
  },
  {
    path: 'document-multipage',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import(
        './document-upload/document-multipage/document-multipage.page'
      ).then(m => m.DocumentMultipagePage),
  },
  {
    path: 'document-upload-direct-deposits',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import(
        './document-upload/direct-deposit/document-upload-direct-deposits.page'
      ).then(m => m.DocumentUploadDirectDepositsPage),
  },

  {
    path: 'document-add-page',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import('./document-upload/document-add-page/document-add-page.page').then(
        m => m.DocumentAddPagePage
      ),
  },
  {
    path: 'support-order',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import('./support-order/support-order.page').then(
        m => m.SupportOrderPage
      ),
  },
  {
    path: 'support-order-detail',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import(
        './support-order/support-order-detail/support-order-detail.page'
      ).then(m => m.SupportOrderDetailPage),
  },
  {
    path: 'docupload-history',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import('./document-upload/docupload-history/docupload-history.page').then(
        m => m.DocuploadHistoryPage
      ),
  },
  {
    path: 'docupload-history-details',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import(
        './document-upload/docupload-history-details/docupload-history-details.page'
      ).then(m => m.DocuploadHistoryDetailsPage),
  },
  {
    path: 'request-appointment',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import('./appointments/request-appointment.page').then(
        m => m.RequestAppointmentPage
      ),
  },
  {
    path: 'request-appointment-options',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import(
        './appointments/request-appointment-options/request-appointment-options.page'
      ).then(m => m.RequestAppointmentOptionsPage),
  },
  {
    path: 'request-appointment-review',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import(
        './appointments/request-appointment-review/request-appointment-review.page'
      ).then(m => m.RequestAppointmentReviewPage),
  },
  {
    path: 'request-appointment-confirmation',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import(
        './appointments/request-appointment-confirmation/request-appointment-confirmation.page'
      ).then(m => m.RequestAppointmentConfirmationPage),
  },
  {
    path: 'user-agreement',
    loadComponent: () =>
      import('./user-account/user-agreement/user-agreement.page').then(
        m => m.UserAgreementPage
      ),
    canLoad: [AuthGuard],
    //canDeactivate: [preventBackButtonGuard],
  },
  {
    path: 'access-menu',
    loadComponent: () =>
      import('./side-menu/access-menu/access-menu.page').then(
        m => m.AccessMenuPage
      ),
  },
  {
    path: 'registration-success',
    loadComponent: () =>
      import(
        './user-account/registration/registration-success/registration-success.page'
      ).then(m => m.RegistrationSuccessPage),
  },
  {
    path: 'payment-history',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import('./payments/payment-history/payment-history.page').then(
        m => m.PaymentHistoryPage
      ),
  },
  {
    path: 'drivers-license',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import('./drivers-license/drivers-license.page').then(
        m => m.DriversLicensePage
      ),
  },
  {
    path: 'license-status',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import('./drivers-license/license-status/license-status.page').then(
        m => m.LicenseStatusPage
      ),
  },
  {
    path: 'deferral-form',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import('./drivers-license/deferral-form/deferral-form.page').then(
        m => m.DeferralFormPage
      ),
  },
  {
    path: 'payment-history-detail',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import(
        './payments/payment-history/payment-history-detail/payment-history-detail.page'
      ).then(m => m.PaymentHistoryDetailPage),
  },
  {
    path: 'payment-history-for-case',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import(
        './payments/payment-history/payment-history-for-case/payment-history-for-case.page'
      ).then(m => m.PaymentHistoryForCasePage),
  },
  {
    path: 'questions',
    loadComponent: () =>
      import('./drivers-license//signature-pad/questions.page').then(
        m => m.QuestionsPage
      ),
  },
  {
    path: 'signature',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import('./drivers-license/signature-pad/signature/signature.page').then(
        m => m.SignaturePage
      ),
  },
  {
    path: 'deferral-review',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import('./drivers-license/deferral-review/deferral-review.page').then(
        m => m.DeferralReviewPage
      ),
  },
  {
    path: 'questions-mrc',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import(
        './drivers-license/signature-pad/questions-mrc/questions-mrc.page'
      ).then(m => m.QuestionsMrcPage),
  },
  {
    path: 'close-my-case',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import('./case-activity/close-my-case/close-my-case.page').then(
        m => m.CloseMyCasePage
      ),
  },
  {
    path: 'close-my-case-success',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import(
        './case-activity/close-my-case-success/close-my-case-success.page'
      ).then(m => m.CloseMyCaseSuccessPage),
  },
  {
    path: 'mra-success',
    canLoad: [AuthGuard],
    loadComponent: () =>
      import('./drivers-license/mra-success/mra-success.page').then(
        m => m.MraSuccessPage
      ),
  },
  {
    path: 'app-download',
    loadComponent: () =>
      import('./side-menu/app-download/app-download.page').then(
        m => m.AppDownloadPage
      ),
  },
  {
    path: 'scheduled-appointments',
    loadComponent: () =>
      import(
        './appointments/scheduled-appointments/scheduled-appointments.page'
      ).then(m => m.ScheduledAppointmentsPage),
    canLoad: [AuthGuard],
  },
  {
    path: 'deferral-payment-options',
    loadComponent: () =>
      import(
        './payments/deferral-payment-options/deferral-payment-options.page'
      ).then(m => m.DeferralPaymentOptionsPage),
    canLoad: [AuthGuard],
  },
  {
    path: 'alert-timer',
    loadComponent: () =>
      import('./alert-timer/alert-timer.page').then(m => m.AlertTimerPage),
  },
  {
    path: 'offline-module',
    loadComponent: () =>
      import('./offline-module/offline-module.page').then(
        m => m.OfflineModulePage
      ),
  },
  {
    path: 'tool-tip',
    loadComponent: () => import('./tooltip/tool-tip/tool-tip.page').then( m => m.ToolTipPage)
  },
];
